import { Dashboard, Exit, SendEmail, Transaction, Users, Verification, Wallet, Contract, API } from "./assets/icons";
import {
  ROUTE_ACCOUNTS,
  ROUTE_DASHBOARD,
  ROUTE_DEPOSIT,
  ROUTE_LOGOUT,
  ROUTE_TRANSACTION,
  ROUTE_CREATE_TRANSACTION,
  ROUTE_VERIFICATION,
  ROUTE_CONTRACTS,
  ROUTE_REQUEST_API
} from "./utils/helpers/roleHelper";

const routes = [
  // {
  //   type: 'MAIN',
  //   title: 'Beranda',
  //   icon: <Dashboard />,
  //   url: '/dashboard',
  //   routeKey: ROUTE_DASHBOARD
  // },
  {
    type: 'MAIN',
    title: 'Pengisian data',
    icon: <Verification />,
    url: '/verification',
    routeKey: ROUTE_VERIFICATION
  },
  {
    type: 'MAIN',
    title: 'Daftar Transaksi',
    icon: <Transaction />,
    url: '/transaction',
    routeKey: ROUTE_TRANSACTION
  },
  {
    type: 'MAIN',
    title: 'Buat Transaksi',
    icon: <SendEmail />,
    url: '/create-transaction',
    routeKey: ROUTE_CREATE_TRANSACTION
  },
  // {
  //   type: 'MAIN',
  //   title: 'Deposit',
  //   icon: <Wallet />,
  //   url: '/deposit',
  //   routeKey: ROUTE_DEPOSIT
  // },
  {
    type: 'MAIN',
    title: 'Kelola Multi Akun',
    icon: <Users />,
    url: '/accounts',
    routeKey: ROUTE_ACCOUNTS
  },
  {
    type: 'MAIN',
    title: 'Kontrak',
    icon: <Contract />,
    url: '/contracts',
    routeKey: ROUTE_CONTRACTS
  },
  {
    type: 'MAIN',
    title: 'Request API',
    icon: <API />,
    url: '/request-api',
    routeKey: ROUTE_REQUEST_API
  },
  {
    type: 'BOTTOM',
    title: 'Keluar',
    icon: <Exit />,
    url: '/logout',
    routeKey: ROUTE_LOGOUT
  }
]

export default routes
